<template>
    <div style="position: relative;height: 70px;margin-top:0px; text-align: center;">
        <!-- <div v-if="showErrorLocate">
            <div style="font-size: 12px;color:#ed4014;">
                <Icon type="md-pin" size="14" color="lightgray" />定位失败,请选择您所在的省/市</div>
        </div> -->
        <Cascader v-model="value" :data="citys" :placeholder="holdertext" trigger="click" change-on-select @on-change="onChange" @on-visible-change="onManualLocate">
            <a href="javascript:void(0)" style="display: block;height:auto;">
                <div class="container">
                    <div class="item item-1"><Icon type="md-pin" size=15 :color="iconColor" :style="{position:'relative',left:'-5px',display:autoLocate?'inline-block':'none'}" />{{value2[0].label}}</div>
                    <div class="item item-2"><Icon type="md-pin" size=15 :color="iconColor" :style="{position:'relative',left:'-5px',display:autoLocate?'inline-block':'none'}" />{{value2[1]!==undefined?value2[1].label:""}}</div>
                </div>
                <div style="margin-top:10px;">切换到其他城市</div>
            </a>
        </Cascader>
        <Spin fix v-if="show">
            <Icon type="ios-pin" size=22 class="demo-spin-icon-load"></Icon>
            <div>{{locateDesc}}</div>
        </Spin>
    </div>
</template>
<script>
import store from '../../../store/'
import ConstJson from "../../../api/common/constjson.js"
let constJ = new ConstJson()
export default {
    name: "CitySelector",
    data() {
        return {
            citys: this.getProvinceCity(),
            selectLocation: [],
            showErrorLocate: false,
            value: [{ label: "　", value: "" },{ label: "　", value: "" }],
            value2: [{ label: "　", value: "" },{ label: "　", value: "" }],
            holdertext: '请选择',
            show: false,
            locateDesc: "基于您的IP地址定位...",
            autoLocate:false,
            iconColor: '#19be6b',
        }
    },
    created() {
        this.autoLocation()
    },
    methods: {
        getProvinceCity() {
            let res = store.state.user.initData.provinceCity
            console.log(res)
            return res

        },
        onChange(val, data) {
            console.log(data)
            this.selectLocation = data
            this.value = data
            if (this.value) {
                if (this.value.length === 1) {
                    this.value2 = []
                    var p = {
                        label: this.value[0].label,
                        value: this.value[0].value
                    }
                    this.value2.push(p)
                }
                if (this.value.length === 2) {
                    this.value2 = []
                    var p = {
                        label: this.value[0].label,
                        value: this.value[0].value
                    }
                    var c = {
                        label: this.value[1].label,
                        value: this.value[1].value
                    }
                    this.value2.push(p)
                    this.value2.push(c)
                    
                }
                this.autoLocate=false
                this.showErrorLocate=false
            }
            this.$emit("on-city-changed", this.value2) //告知到左侧树所选的城市数据
        },
        onManualLocate(isChange) {
            if (isChange === false && this.selectLocation.length > 0) {
                //this.iconColor = '#c5c8ce'
            }

        },
        autoLocation(){
            constJ.ReqGetLocation().then(res => {
            console.log(res)
            if (res.rltcode === 1) {
                if (res.rtncode === 1) {
                    this.value = []
                    this.value.push(res.postion.provice)
                    this.value.push(res.postion.city)

                    this.value2 = []
                    var p = {
                        label: res.postion.provicelabel,
                        value: res.postion.provice
                    }
                    var c = {
                        label: res.postion.citylabel,
                        value: res.postion.city
                    }
                    this.value2.push(p)
                    this.value2.push(c)
                    this.autoLocate=true
                    this.$emit('autoLocation',this.value2)
                } else {
                    this.locateDesc = res.rtncode
                    this.showErrorLocate=true
                }
            } else {
               if (res.rltcode === -1) {
                    this.autoLocate = false
                    this.showErrorLocate = true
                    this.value2 = []
                    var p = {
                        label: res.postion.provicelabel,
                        value: res.postion.provice
                    }
                    this.value2.push(p)
                    this.$emit('autoLocation',this.value2)//触发右侧列表显示
                } else {
                    //-9998
                    this.locateDesc = res.rltdesc
                    this.showErrorLocate = true
                }
            }

            this.show = false
        }).catch(err => {
            this.locateDesc = "定位失败,请手动选择"
            setTimeout(() => {
                this.value2 = this.value
                this.value = Array.from(this.value, (x) => x.value)
                this.show = false
            }, 1000 * 2)
            console.log(err)
        })
        }
    },
    mounted() {},
    components: {},
}
</script>
<style scoped>
/*spin style*/
.demo-spin-icon-load {
    /*animation: ani-demo-spin 1s linear infinite;*/
    animation: blink 1s infinite;
    -webkit-animation: blink 1s infinite;
    /*Safari and Chrome*/

}

@keyframes blink {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 100;
    }

    100% {
        opacity: 0;
    }
}

@-webkit-keyframes blink {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 100;
    }

    100% {
        opacity: 0;
    }
}

.demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}

.container {
    width: 180px;
    /*  height: 26px;*/
    display: inline-grid;
    grid-template-columns: 50% 50%;
    margin: auto;
}

.item {
    font-size: 12px;
    text-align: center;
    border: 1px solid #2d8cf0;
    color: #17233d;
    padding: 5px;
    font-weight: bold;
    /*  height:40px;
  line-height: 40px;*/
}

.item-1 {
    background-color: white;
    margin-right:5px;

}

.item-2 {
    background-color: white;


}

.item-1:hover {
    background-color: #F4FFF9;
}

.item-2:hover {
    background-color: #F4FFF9;
}
</style>